module.exports = __webpack_public_path__ + "static/media/portfolio-img7.1751e3cc.jpg";